// <grid-columns>: shopper column switch for the collection grid (desktop 2-5, mobile 1-2), remembered in localStorage.
const STORAGE_KEY = 'nawiya-grid-columns';
const ALLOWED = { desktop: [2, 3, 4, 5], mobile: [1, 2] };
const PROPERTY = { desktop: '--discovery-desktop-columns', mobile: '--discovery-mobile-columns' };

export function readPreference(raw) {
  let saved = {};
  try { saved = JSON.parse(raw || '{}') || {}; } catch { saved = {}; }
  const result = {};
  for (const context of Object.keys(ALLOWED)) {
    const value = Number(saved[context]);
    if (ALLOWED[context].includes(value)) result[context] = value;
  }
  return result;
}

export function writePreference(raw, context, value) {
  if (!ALLOWED[context]?.includes(value)) return raw || '{}';
  return JSON.stringify({ ...readPreference(raw), [context]: value });
}

const storage = {
  get() { try { return localStorage.getItem(STORAGE_KEY); } catch { return null; } },
  set(value) { try { localStorage.setItem(STORAGE_KEY, value); } catch { /* Preference is optional. */ } }
};

class GridColumns extends (globalThis.HTMLElement ?? class {}) {
  connectedCallback() {
    this.section = this.closest('[data-discovery]');
    if (!this.section || this.controller) return;
    this.controller = new AbortController();
    this.addEventListener('click', (event) => {
      const button = event.target.closest('[data-columns]');
      if (!button) return;
      const context = button.closest('[data-columns-group]').dataset.columnsGroup;
      const value = Number(button.dataset.columns);
      storage.set(writePreference(storage.get(), context, value));
      this.apply(context, value);
    }, { signal: this.controller.signal });
    const saved = readPreference(storage.get());
    for (const context of Object.keys(ALLOWED)) if (saved[context]) this.apply(context, saved[context]);
  }

  disconnectedCallback() {
    this.controller?.abort();
    this.controller = null;
  }

  apply(context, value) {
    this.section.style.setProperty(PROPERTY[context], String(value));
    this.section.dataset[`${context}Columns`] = String(value);
    for (const button of this.querySelectorAll(`[data-columns-group="${context}"] [data-columns]`)) {
      button.setAttribute('aria-pressed', String(Number(button.dataset.columns) === value));
    }
  }
}

if (typeof customElements !== 'undefined' && !customElements.get('grid-columns')) customElements.define('grid-columns', GridColumns);
